import { stepConfig } from "../../consts/stepConfig";

let steps = {};

for (var i = stepConfig.length - 1; i >= 0; i--) {
  steps[stepConfig[i].name] = require("./" + stepConfig[i].path).default;
}

export default steps;



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/StepIndex.js